var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconRefresh = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1473 5.15263C15.4786 4.82127 15.4963 4.28419 15.1477 3.97109C13.783 2.74557 11.9786 2 10 2C5.74353 2 2.29297 5.45057 2.29297 9.70705C2.29297 10.0418 2.57407 10.2999 2.90885 10.2999H3.50697C3.82498 10.2999 4.07151 10.0251 4.07151 9.70705C4.07151 6.43283 6.72579 3.77855 10 3.77855C11.4477 3.77855 12.7742 4.29743 13.8036 5.15936C14.1958 5.48775 14.7856 5.51435 15.1473 5.15263Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33418 13.5939C3.26664 13.7109 3.09779 13.7109 3.03025 13.5939L1.02377 10.1186C0.956232 10.0016 1.04066 9.85536 1.17573 9.85536H5.18869C5.32377 9.85536 5.4082 10.0016 5.34066 10.1186L3.33418 13.5939Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6658 5.8204C16.7334 5.70342 16.9022 5.70342 16.9697 5.8204L18.9762 9.29573C19.0438 9.41271 18.9593 9.55894 18.8243 9.55894L14.8113 9.55893C14.6762 9.55893 14.5918 9.41271 14.6593 9.29573L16.6658 5.8204Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 17.4141C14.2565 17.4141 17.707 13.9635 17.707 9.70701C17.707 9.37223 17.4259 9.11416 17.0912 9.11416L16.493 9.11416C16.175 9.11416 15.9285 9.389 15.9285 9.70701C15.9285 12.9812 13.2742 15.6355 9.99997 15.6355C8.55231 15.6355 7.22583 15.1166 6.19638 14.2547C5.80416 13.9263 5.21442 13.8997 4.85271 14.2614C4.52135 14.5928 4.50365 15.1299 4.85231 15.443C6.21698 16.6685 8.02141 17.4141 9.99998 17.4141Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRefresh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-refresh.88547e4c.svg";
export { ForwardRef as ReactComponent };